<template>
    <div>


      <div class="row">
        <div class="col-xs-12 col-sm-6 col-sm-offset-3">

          <h2>Review and Deploy in AWS</h2>
          <em>Tell us about yourself</em><br />
          <em>We'll redirect you to AWS where you can review and deploy Skippr</em>

          <div class="m-t" role="form" _lpchecked="1">
            <input id="deploy-skippr" type="hidden" name="_token" value="TVkumuyrNWs5Z2OdjyHv2FKxaKnnbMPJxAasm9Db">

            <div class="form-group">
              <input id="first_name" type="text" class="form-control" name="first_name" placeholder="First Name" v-on:input="customer.firstname = $event.target.value" required="" autofocus="">
            </div>

            <div class="form-group">
              <input id="last_name" type="text" class="form-control" name="last_name" placeholder="Last Name" v-on:input="customer.lastname = $event.target.value" required="" autofocus="">
            </div>

<!--            <div class="form-group">-->
<!--              <input id="company_name" type="text" class="form-control" name="company_name" placeholder="Company Name" v-on:input="customer.company = $event.target.value" required="" autofocus="">-->

<!--            </div>-->

            <div class="form-group">

              <input id="email" type="email" class="form-control" name="email" placeholder="Email" v-on:input="customer.email = $event.target.value" required="">

            </div>

<!--            <div class="form-group">-->

<!--              <input id="phone" type="phone" class="form-control" name="password" placeholder="Phone" required="" v-on:input="customer.phone = $event.target.value">-->

<!--            </div>-->


            <div class="form-group">
              <div class="checkbox">
                <label>
                  <div class="icheckbox_square-green">
                    <input type="checkbox" required="">
                    <ins class="iCheck-helper"></ins>
                  </div><i></i> I agree to the <a href="/terms" target="_blank">terms and privacy policy</a>
                </label>

              </div>
            </div>

<!--            <a href="https://console.skippr.io/register" class="btn btn-secondary" type="submit">Try The Beta</a>-->

          </div>


          <button v-on:click="awsCreateStack()" class="btn btn-primary block pull-right full-width m-b">Review and Deploy <i class="fa fa-arrow-circle-right"></i></button>

        </div>
      </div>

    </div>
</template>

<script>

    export default {
        name: 'BetaSignup',
        components: {
        },
        props: {
            msg: String,
            awsRegion: String,
        },
        data() {
          return {
            customer: {
              firstname: '',
              lastname: '',
              company: '',
              email: '',
              phone: '',
            }
          }
        },
        methods: {
          clickEvent(name) {
            this.$gtag.event('click', {
              event_category: 'deploy-wizard',
              event_label: name,
            })
          },
          awsCreateStack() {

            this.clickEvent('complete-contact-from')

            if (this.awsRegion) {

              window.axioslicense.post('create', this.customer).then((res) => {

                // do redirect
                let license_key = res.data.license_key

                window.location = 'https://eu-west-2.console.aws.amazon.com/cloudformation/home?region=' + this.awsRegion+ '#/stacks/quickcreate?templateURL=https://skpr-cloudformation.s3.amazonaws.com/cloudformation-lite-prod.json&stackName=Skippr&param_LicenseKey=' + license_key

              }).catch((err) => {

                console.log(err)
              });

            }

          },
        },
        head: {

            title: {
                inner: 'Beta Signup Skippr',
                separator: '-',
                complement: 'Data Integration and Preparation'
            },
            //omited
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
